import { Component } from '@verndale/core';
import { ActionsToCart } from '../helpers/cart';

class CourseScheduleSelector extends Component {
  selectedCode: string;
  quantity: number;
  endpoint: string;

  constructor(el: HTMLElement) {
    super(el);
    this.selectedCode = '';
    this.quantity = 0;
    this.endpoint = this.el.dataset.endpoint || '';
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      radioButtons: this.el.querySelectorAll<HTMLElement>('input[type="radio"]'),
      submitBtn: this.el.querySelector<HTMLElement>('.btn.btn--primary')
    };
  }

  addListeners() {
    (this.dom.radioButtons as NodeList).forEach(radioButton => {
      radioButton.addEventListener('change', this.handleRadioButtonChange.bind(this));
    });
    (this.dom.submitBtn as HTMLElement).addEventListener(
      'click',
      this.handleSubmitButtonClick.bind(this)
    );
  }

  handleRadioButtonChange(event: Event) {
    const elementData = (event.target as HTMLInputElement).parentElement?.parentElement?.dataset;
    this.selectedCode = elementData?.code || '';
    this.quantity = parseInt(elementData?.quantity || '0', 10);
    (this.dom.submitBtn as HTMLElement).classList.remove('btn--disabled');

    const stickySelect = document.querySelector<HTMLSelectElement>('.sticky-bar__actions select');
    if (stickySelect) {
      stickySelect.value = this.selectedCode;
    }
  }

  handleSubmitButtonClick(event: Event) {
    event.preventDefault();

    const data = {
      code: this.selectedCode,
      quantity: this.quantity
    };

    ActionsToCart(this.endpoint, data);
  }
}

export default CourseScheduleSelector;
